export default __webpack_public_path__ + "static/media/Group 3381.361b89ff.png";